// 422系
export const E_PHONE_NUMBER_AUTHORIZATION_FAILED = 4222;
